module.exports = __webpack_public_path__ + "img/es.fbaa776c.svg";